export default {
  setDarkMode(context) {
    context.commit('setDarkMode')
  }
}
